module.exports = __webpack_public_path__ + "static/media/wallfinishes_material_60yd_y.996c8b0b.csv";